<template>
  <td>
    <div>{{ formatSchedule(appointmentData.schedule) }}</div>
  </td>
  <td>
    <div>{{ appointmentData.specialty_name }}</div>
  </td>
  <td>
    <div>{{ appointmentData.vet_name }}</div>
  </td>
  <td>
    <div>{{ appointmentData.customer_name }}</div>
  </td>
  <td>
    <div>{{ appointmentData.pet_name }}</div>
  </td>
  <td v-if="considerInsurance">
    <div>{{ appointmentData.pet_policy }}</div>
  </td>
  <td>
    <div>{{ appointmentData.price }}</div>
  </td>
  <td>
    <div>{{ appointmentData.appointment_status }}</div>
  </td>
  <td>
    <div>{{ appointmentData.status_date }}</div>
  </td>
  <td>
    <div class="is-flex is-justify-content-start" style="gap: 1em;">
      <button type="button" class="button is-warning is-small"
      :class="{ 'is-loading': detailsLoading }"
      :disabled="detailsLoading"
      @click="iniAppointmentData(appointmentData)">{{ $t('General.Details') }}</button>
    </div>
  </td>
</template>


<script lang="ts">
import { defineComponent, defineProps, onMounted } from 'vue'
import { useStore } from "vuex";
import { Notyf } from "notyf";
import { useI18n } from 'vue-i18n';

const props = defineProps(['appointmentData'])
const store = useStore()

const notyf = new Notyf()

export default defineComponent({
  name: "MngAppointmentRecordTableRow",

  methods: {
    formatSchedule(schedule: string): string
    {
      // Split the schedule string by space
      const parts = schedule.split(' ');
      // Split the time part (parts[1]) by ':'
      const timeParts = parts[1].split(':');
      // Combine the date part (parts[0]) and only the hour and minute parts of the time
      return parts[0] + ' ' + timeParts[0] + ':' + timeParts[1];
    }
  }
})

</script>
<script lang="ts" setup>
import { ref, computed } from 'vue';

const props = defineProps(['appointmentData'])
const store = useStore()
const detailsLoading = ref(false);

const considerInsurance = computed(() => process.env.VUE_APP_CONSIDER_INSURANCE === "true");

async function iniAppointmentData(showAppointmentData: any)
{
  detailsLoading.value = true;
  try
  {
    await store.dispatch('iniEditedAppointment', showAppointmentData.appointment_id);
    await store.dispatch('resetAppointmentFiles');
    await store.dispatch('iniEditedAppointmentFiles', showAppointmentData.appointment_id);

    store.dispatch('toggleAppointmentDetailing', false);
    store.dispatch('toggleShowingAppointmentData', false);
  }
  finally
  {
    detailsLoading.value = false;
  }

}

</script>
<style scoped>
.pointer {
  cursor: pointer;
}
</style>